export default __webpack_public_path__ + "static/media/hero-background-v2.ece64318.jpg";